"use client";
import { Link } from "@/i18n/navigation";
import RaffaelloText from "../brand/RaffaelloText";
import NavMenu from "./NavMenu";

import { FC } from "react";


const routes = [
  { title: "Features", href: "#features" },
  { title: "Reasources", href: "#resources" },
  { title: "Pricing", href: "#pricing" },
  { title: "Testimonials", href: "#testimonial" },
];

const components: { title: string; href: string; description: string }[] = [
  {
    title: "Alert Dialog",
    href: "#",
    description:
      "A modal dialog that interrupts the user with important content and expects a response.",
  },
  {
    title: "Hover Card",
    href: "#",
    description:
      "For sighted users to preview content available behind a link.",
  },
  {
    title: "Progress",
    href: "#",
    description:
      "Displays an indicator showing the completion progress of a task, typically displayed as a progress bar.",
  },
  {
    title: "Scroll-area",
    href: "#",
    description: "Visually or semantically separates content.",
  },
  {
    title: "Tabs",
    href: "#",
    description:
      "A set of layered sections of content—known as tab panels—that are displayed one at a time.",
  },
  {
    title: "Tooltip",
    href: "#",
    description:
      "A popup that displays information related to an element when the element receives keyboard focus or the mouse hovers over it.",
  },
];
interface NavBarProps {}

const NavBar: FC<NavBarProps> = ({}) => {
  // const { isSubscribed } = await getUserSubscriptionPlan(user);
  // console.log("✅✅ isSubscribed", isSubscribed);
  // const pathname = usePathname();
  // console.log("✅ pathname", pathname);

  return (
    <div className="flex w-full flex-row">
      <Link
        href="/"
        className="flex  items-center"
        title="raffaello - Your AI Web Developr"
      >
        <RaffaelloText className="hidden md:block  pl-2 hover:opacity-80" />

      </Link>
      <div className="flex w-full justify-center">
        <NavMenu />
      </div>
    </div>
  );
};
export default NavBar;